import { render } from "./RemoteUsers.vue?vue&type=template&id=c9051c8e&ts=true"
import script from "./RemoteUsers.vue?vue&type=script&lang=ts"
export * from "./RemoteUsers.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__